export default [{
  path: '/parcelamento-mei/das',
  component: {
    name: 'parcelamentoMeiBase',
    template: '<router-view />',
    meta: {
      resource: 'parcelamento_dasmei',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'parcelamento_dasmei-view',
    component: () => import('@/app/parcelamentos-mei/parcelamento-das/ParcelamentoDasView.vue'),
    meta: {
      tipo: 'das',
      resource: 'parcelamento_dasmei',
      action: 'read',
      navActiveLink: 'parcelamento_dasmei-view',
      pageTitle: 'Parcelamento MEI',
      breadcrumb: [
        {
          text: 'Parcelamento MEI',
          to: { name: 'parcelamento_dasmei-view' },
          active: true,
        },
      ],
    },
  }],
},
]
